import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomDataset, BackendQueryGetCustomDatasetsArgs } from 'src/types/backend';

import { CUSTOM_DATASET_FRAGMENT } from './schema';

const QUERY = gql`
  query CustomerCustomDataset(
    $customerId: ID!
    $brandVoiceIds: [ID!]
    $customDatasetId: ID
    $dataSource: PerformanceCenterDataSource
  ) {
    getCustomDatasets(
      customerId: $customerId
      brandVoiceIds: $brandVoiceIds
      customDatasetId: $customDatasetId
      dataSource: $dataSource
    ) {
      ...CustomDataset
    }
  }
  ${CUSTOM_DATASET_FRAGMENT}
`;

type Variables = BackendQueryGetCustomDatasetsArgs;
type Result = BackendCustomDataset[];

export const queryCustomModels = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
